/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateProtocolDeploymentRequest
 */
export interface UpdateProtocolDeploymentRequest {
    /**
     * User email address
     * @type {string}
     * @memberof UpdateProtocolDeploymentRequest
     */
    email: string;
    /**
     * Whether the user is awaiting protocol deployment
     * @type {boolean}
     * @memberof UpdateProtocolDeploymentRequest
     */
    isAwaitingProtocolDeployment: boolean;
}

/**
 * Check if a given object implements the UpdateProtocolDeploymentRequest interface.
 */
export function instanceOfUpdateProtocolDeploymentRequest(value: object): value is UpdateProtocolDeploymentRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('isAwaitingProtocolDeployment' in value) || value['isAwaitingProtocolDeployment'] === undefined) return false;
    return true;
}

export function UpdateProtocolDeploymentRequestFromJSON(json: any): UpdateProtocolDeploymentRequest {
    return UpdateProtocolDeploymentRequestFromJSONTyped(json, false);
}

export function UpdateProtocolDeploymentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateProtocolDeploymentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'isAwaitingProtocolDeployment': json['isAwaitingProtocolDeployment'],
    };
}

export function UpdateProtocolDeploymentRequestToJSON(json: any): UpdateProtocolDeploymentRequest {
    return UpdateProtocolDeploymentRequestToJSONTyped(json, false);
}

export function UpdateProtocolDeploymentRequestToJSONTyped(value?: UpdateProtocolDeploymentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'isAwaitingProtocolDeployment': value['isAwaitingProtocolDeployment'],
    };
}

